"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.translationsNamespace = exports.defaultTranslations = void 0;
/* istanbul ignore file @preserve */ /**
 * DO NOT EDIT!
 * This file was autogenerated by npm script `localizations-codegen`.
 * Changes may cause incorrect behavior and will be lost when the file is regenerated.
 *
 * Run `npx localizations-codegen` to regenerate.
 */ const defaultTranslations = exports.defaultTranslations = {
    add: 'Add',
    loading: 'Loading',
    noDataFound: 'No data found',
    placeholder: 'Product number',
    qty: 'Qty'
};
const translationsNamespace = exports.translationsNamespace = 'checkout-quick-order-form';
